import type { RouteRecordRaw } from 'vue-router';

export const featureRoutes: Array<RouteRecordRaw> = [
  {
    path: '/feature',
    name: 'feature',
    redirect: '/feature/list',
    component: () => import('pages/trade/admin/feature/McFeature.vue'),
    meta: {
      title: 'Features',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'featureList',
        component: () => import('pages/trade/admin/feature/FeatureList.vue'),
        meta: {
          title: 'Features List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'featureDetail',
        component: () => import('pages/trade/admin/feature/FeatureDetail.vue'),
        meta: {
          title: 'Feature Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'featureNew',
        component: () => import('pages/trade/admin/feature/FeatureNew.vue'),
        meta: {
          title: 'New Feature',
          requiresAuth: true,
        },
      },
    ],
  },
];
